module.exports = __webpack_public_path__ + "img/shot_img122403.2c99406e.gif";